import React from 'react';
import { LayoutIcon, InheritProps } from './Layout';

export function BuyBoxIcon(props: InheritProps) {
  return (
    <LayoutIcon
      {...props}
      childrenRender={(color: string) => (
        <svg
          width='100%'
          height='100%'
          viewBox='0 0 100 100'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='xMidYMid meet'
        >
          <rect
            x='1.5'
            y='1.5'
            width='97'
            height='97'
            rx='8.5'
            fill='#343434'
            stroke={color}
            strokeWidth='3'
          />
          <path
            d='M48 40C48 38.3431 49.3431 37 51 37H58C59.6569 37 61 38.3431 61 40V47C61 48.6569 59.6569 50 58 50H51C49.3431 50 48 48.6569 48 47V40Z'
            fill='#D9D9D9'
          />
          <path
            d='M9 18C9 16.3431 10.3431 15 12 15H41C42.6569 15 44 16.3431 44 18V47C44 48.6569 42.6569 50 41 50H12C10.3431 50 9 48.6569 9 47V18Z'
            fill='#595959'
          />
          <path
            d='M9 58C9 56.3431 10.3431 55 12 55H89C90.6569 55 92 56.3431 92 58V59C92 60.6569 90.6569 62 89 62H12C10.3431 62 9 60.6569 9 59V58Z'
            fill='#595959'
          />
          <path
            d='M9 70C9 68.3431 10.3431 67 12 67H89C90.6569 67 92 68.3431 92 70V71C92 72.6569 90.6569 74 89 74H12C10.3431 74 9 72.6569 9 71V70Z'
            fill='#595959'
          />
          <path
            d='M9 82C9 80.3431 10.3431 79 12 79H89C90.6569 79 92 80.3431 92 82V83C92 84.6569 90.6569 86 89 86H12C10.3431 86 9 84.6569 9 83V82Z'
            fill='#595959'
          />
          <path
            d='M48 18C48 16.3431 49.3431 15 51 15H89C90.6569 15 92 16.3431 92 18V19C92 20.6569 90.6569 22 89 22H51C49.3431 22 48 20.6569 48 19V18Z'
            fill='#595959'
          />
          <path
            d='M48 28C48 26.3431 49.3431 25 51 25H68C69.6569 25 71 26.3431 71 28V29C71 30.6569 69.6569 32 68 32H51C49.3431 32 48 30.6569 48 29V28Z'
            fill='#595959'
          />
          <path
            d='M64 40C64 38.3431 65.3431 37 67 37H73C74.6569 37 76 38.3431 76 40V47C76 48.6569 74.6569 50 73 50H67C65.3431 50 64 48.6569 64 47V40Z'
            fill='#D9D9D9'
          />
          <path
            d='M79 40C79 38.3431 80.3431 37 82 37H89C90.6569 37 92 38.3431 92 40V47C92 48.6569 90.6569 50 89 50H82C80.3431 50 79 48.6569 79 47V40Z'
            fill='#D9D9D9'
          />
        </svg>
      )}
    />
  );
}
